// extracted by mini-css-extract-plugin
export default {"date":"date--I7ArR","watcherName":"watcherName--mZppv","watcherNameEmail":"watcherNameEmail--mOC0U"};